


























































import {
    createComponent,
    onMounted,
    ref,
    Ref,
    watch,
} from '@vue/composition-api'

import Vue from 'vue'
import { Store } from 'vuex'
// import VueRouter from 'vue-router'
import { Message, MessageBox } from 'element-ui'
import isElectron from 'is-electron'
import { TableFile, IFile } from '@oppo/slice-uploader/src/types'
import {
    desktopUploadHandler,
} from '@/service/allUse'
import {
    SameFileType,
    getCompressList,
    CompressListItem,
    getUnzipList,
    UnzipListItem,
} from '@/service/public'

import SliceUploader from '../components/SliceUploader.vue'
import UnZipList from '../components/UnZipList.vue'
import ZipList from '../components/ZipList.vue'
import request from '@/helpers/customAxios'
import { useRouter, useStore } from '@/hooks/common'
const inElectron = isElectron()

function useUploader(store: Store<any>, Uploader: Ref<Vue|null>) { // 包括拖拽上传
    const dirId = ref('')
    const uploadFileLength = ref(0)
    const checkFileHandler = res => {
        if (res && res.code === 0) {
            return true
        }
        return false
    }
    
    const checkSameFile = async (file: TableFile) => {
        const query = {
            name: file.name,
            dirId: store.state.publicStore.currentDirId,
        }
        let checkType: SameFileType
        let newName = ''
        try {
            let res
            res = await request.get('/api/checkFile', { params: query })
            let sameNameObj
            if (!res || (res && res.code !== 0)) {
                Message.error('检查文件重名出错！')
                return { checkType: SameFileType.ERROR }
            }
            if (res.code === 0) {
                sameNameObj = res.data
            }
            if (sameNameObj) {
                checkType = sameNameObj.identifier === file.id ? SameFileType.SAME_MD5 : SameFileType.SAME_NAME
                newName = sameNameObj.rename
            } else {
                checkType = SameFileType.NOT_SAME
            }
        } catch (e) {
            Message.error('检查文件重名出错！')
            checkType = SameFileType.ERROR
        }

        return { checkType, newName }
    }
    const handleSameFile = async (fileName: string, param: { checkType: SameFileType; newName: string }) => {
        const { checkType, newName } = param
        return new Promise((resolve, reject) => {
            let saveFile = true
            if (checkType === SameFileType.ERROR) {
                saveFile = false
                resolve({ saveFile })
            } else if (checkType === SameFileType.SAME_NAME) {
                const newFileName = newName
                MessageBox.confirm(`系统将上传文件更名为${newFileName},是否继续执行该操作`, '当前路径存在相同文件名', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        resolve({
                            saveFile,
                            newFileName,
                        })
                    })
                    .catch(() => {
                        saveFile = false
                        resolve({
                            saveFile,
                            newFileName,
                        })
                    })
            } else {
                if (checkType === SameFileType.SAME_MD5) {
                    saveFile = false
                    Message.success('文件已存在！')
                }
                resolve({ saveFile })
            }
        })
    }
    const shouldAddedFilesUpload = async (files: FileList) => {
        const isContinue = true
        if (isContinue) {
            return files
        } else {
            return []
        }
    }
    const checkFileUploadedChunks = res => {
        let data = []
        if (res && res.code === 0 && res.data && res.data.length) {
            data = res.data.map(v => {
                // 后台索引是1开始的
                return v - 1
            })
        }
        if (res && res.code != 0) {
            Message.error(res.desc)
        }
        return data
    }
    const onFileSuccess = (res, file: TableFile) => {
        store.dispatch('publicStore/getTableData')
    }
    const onFileError = (res, file: TableFile) => {
        const msg = `${file.name} | ${res.desc || '文件上传失败[未知原因]'}`
        Message.error(msg)
    }
    const onFilecheckError = (err: any, file: IFile) => {
        const msg = `${file.name} | ${err.desc || '文件上传失败[未知原因]'}`
        Message.error(msg)
    }
    const onFileMd5Error = () => {
        Message.error('计算文件MD5失败')
    }
    const onFilelistLengthChange = val => {
        uploadFileLength.value = val
    }

    watch(
        ()=> store.state.operateStore.dragUploadFiles,
        (newVal)=>{
            if(newVal && newVal.length){
                (Uploader.value as any).selectDrapFile(newVal)
            }
        }
    )
    // 传数据进入spliceUploadFile，每次上传的id都是初始化的id，所以强行更改
    watch(
        () => store.state.publicStore.uploadDirId,
        () => {
            let id = store.state.publicStore.uploadDirId || '0'
            dirId.value = id
        }
    )

    return {
        dirId,
        checkFileHandler,
        shouldAddedFilesUpload,
        checkFileUploadedChunks,
        onFileSuccess,
        onFileError,
        onFilecheckError,
        handleSameFile,
        checkSameFile,
        onFilelistLengthChange,
        onFileMd5Error,
        uploadFileLength,
    }
}
function useTaskDialog(store: Store<any>, Uploader: Ref<Vue|null>) {
    // 弹窗展示
    const taskListBox = ref<'show-task' | 'fold-task' | 'close-task'>('fold-task')
    const handleFoldTaskDialog = () => {
        taskListBox.value = 'fold-task'
    }
    const dialogUnZipData = ref<UnzipListItem[]>([]) 

    const dialogCompressData = ref<CompressListItem[]>([])
    const isShowLoad = ref(false)
    const activeTabName = ref('upload')

    const uploadHandler = async () => {
        const currentDirId = store.state.publicStore.currentDirId
        store.commit('publicStore/SET_UPLOAD_DIR_ID', currentDirId)
        if (inElectron) {
            // eslint-disable-next-line no-constant-condition
            console.log('上传请求客户端')
            desktopUploadHandler(currentDirId)
        } else {
            (Uploader.value as any).selectFile()
        }
    }
    const handleOpenTaskDialog = type => {
        taskListBox.value = 'show-task'
        if (type === 'upload') {
            uploadHandler()
        }
    }
    const handleRefreshTaskList = async (type?: 'unzip' | 'gzip') => {
        isShowLoad.value = true
        if (activeTabName.value === 'unzip' || type === 'unzip') {
            const res = await getUnzipList()
            if (res && res.code === 0 && res.data) {
                // store.commit('operateStore/SET_UNZIP_DATA', res.data)
                dialogUnZipData.value = res.data
            } else {
                dialogUnZipData.value = []
                // store.commit('operateStore/SET_UNZIP_DATA', [])
            }
        }
        if (activeTabName.value === 'gzip' || type === 'gzip') {
            const res = await getCompressList()
            if (res && res.code === 0 && res.data) {
                dialogCompressData.value = res.data
            } else {
                dialogCompressData.value = []
            }
        }
        isShowLoad.value = false
    }

    const handleTabClick = tab => {
        activeTabName.value = tab.paneName
        handleRefreshTaskList()
    }
    watch(
        () => store.state.publicStore.updateCompressList,
        () => {
            handleRefreshTaskList('gzip')
        },
        {
            lazy: true,
        }
    )
    watch(
        () => store.state.publicStore.updateUnzipList,
        () => {
            handleRefreshTaskList('unzip')
        },
        {
            lazy: true,
        }
    )
    watch(
        () => store.state.operateStore.openFilePath,
        () => {
            handleOpenTaskDialog('upload')

        },
        {
            lazy: true
        }
    )
    onMounted(() => {
        handleRefreshTaskList('unzip')
        handleRefreshTaskList('gzip')
    })
    return {
        Uploader,
        uploadHandler,
        taskListBox,
        handleFoldTaskDialog,
        handleOpenTaskDialog,
        handleRefreshTaskList,
        activeTabName,
        handleTabClick,
        dialogUnZipData,
        dialogCompressData,
        isShowLoad,
    }
}
// function useUpload (store: Store<any>, Uploader: Ref<Vue| null>){ // public 页面拖拽上传
   
// }

export default createComponent({
    components: {
        SliceUploader,
        UnZipList,
        ZipList,
    },
    setup(props, setupContext) {
        const store = useStore()
        const router = useRouter()
        const Uploader = ref(null)

        const useSliceUploader = useUploader(store, Uploader)
        const taskDialog = useTaskDialog(store, Uploader)
       
        return {
            isElectron,
            ...useSliceUploader,
            // DragState,
            ...taskDialog,
            Uploader
        }
       

    }
})
